import React from 'react'
import { smoothLoad } from '../../helpers'
import Link from 'next/link'
import Image from 'next/image'

const PressLink = ({ article }) => {
  const { logo, alt, date, route } = article

  return (
    <Link legacyBehavior href={`/press/${route}`}>
      <a>
        <div className='press-image'>
          <Image src={logo} alt={alt} {...smoothLoad} />
        </div>
        {date}
      </a>
    </Link>
  )
}

const PressLinks = ({ data }) => {
  return (
    <div className="press-links">
      {data.map((article, i) => (
        <PressLink key={i} {...{ article }} />
      ))}
    </div>
  )
}

export default PressLinks
